import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  track: {
    background: "#333333",
    height: 3,
    borderRadius: 75,
    position: "relative"
  },
  slider: {
    position: "absolute",
    left: 0,
    height: "100%",
    borderRadius: 75,
    "&.naAlert": {
      stroke: theme.palette.primary.light
    },
    "&.nonAlert": {
      background: theme.palette.secondary.dark
    },
    "&.middleAlert": {
      background: "#eab32f"
    },
    "&.moderateAlert": {
      background: theme.palette.warning.main
    },
    "&.highAlert": {
      background: theme.palette.warning.dark
    }
  },
  sliderExtended: {
    height: "7px"
  },
  donutChart: {
    height: 36,
    width: 36,
    margin: 0,
    position: "relative"
  },
  donutSvg: {
    width: "100%",
    height: "100%",
    transform: "rotate(-90deg)",
    borderRadius: "50%"
  },
  donutCircle: {
    fill: "#222222",
    strokeWidth: 32,
    strokeDasharray: "0 100",
    transition: "stroke-dasharray 0.5s ease",
    "&.naAlert": {
      stroke: theme.palette.primary.light,
      fill: theme.palette.primary.light
    },
    "&.nonAlert": {
      stroke: theme.palette.secondary.dark
    },
    "&.middleAlert": {
      stroke: "#eab32f"
    },
    "&.moderateAlert": {
      stroke: theme.palette.warning.main
    },
    "&.highAlert": {
      stroke: theme.palette.warning.dark
    }
  },
  lineChartText: {
    display: "none",
    "&.highAlert": {
      color: theme.palette.warning.dark
    },
    "&.naAlert": {
      color: theme.palette.text.secondary
    }
  },
  text: {
    fontSize: 14,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    whiteSpace: "nowrap",
    "&.nonAlert": {
      color: theme.palette.secondary.dark
    },
    "&.naAlert": {
      color: theme.palette.text.secondary
    },
    "&.middleAlert": {
      color: "#eab32f"
    },
    "&.moderateAlert": {
      color: theme.palette.warning.main
    },
    "&.highAlert": {
      color: theme.palette.warning.dark
    }
  },
  donutChartCenter: {
    background: "#fff",
    borderRadius: "50%",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  donutChartCenterText: {
    fontSize: 13,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    "&.naAlert": {
      color: theme.palette.text.secondary
    }
  },
  decreasedFontSize: {
    fontSize: 11
  },
  maxHeight: {
    maxHeight: "100%",
    height: "100%"
  },
  scrollable: {
    height: "100%",
    overflowY: "auto"
  }
}));
